/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const OffsetsSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10.456 2c1.617 0 3.06.74 4.007 1.9a4.039 4.039 0 0 1 1.151-.167c2.22 0 4.02 1.79 4.02 3.999 0 .464-.08.91-.226 1.325a5.107 5.107 0 0 1 1.7 3.807c0 2.835-2.31 5.132-5.16 5.132a5.156 5.156 0 0 1-2.38-.577V21.5c0 .276-.224.5-.502.5h-2.01a.501.501 0 0 1-.502-.5v-4.848a5.158 5.158 0 0 1-2.38.578c-2.85 0-5.159-2.298-5.159-5.132 0-1.794.925-3.373 2.327-4.29a5.155 5.155 0 0 1-.045-.676C5.297 4.298 7.607 2 10.456 2Z" /></svg>);
const OffsetsSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={OffsetsSolidBase} {...rest} ref={ref} />);
export default OffsetsSolid;